import _ from "lodash";

export const S3Uploader = (entries, onViewError) => {
  for (const entry of entries) {
    const xhr = new XMLHttpRequest();
    onViewError(() => xhr.abort());

    xhr.onload = () => {
      if (_.inRange(xhr.status, 200, 299)) {
        entry.progress(100);
      } else {
        entry.error();
      }
    };
    xhr.onerror = () => entry.error();
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        entry.progress(percent);
      }
    });

    xhr.open("PUT", entry.meta.presigned_url, true);
    xhr.send(entry.file);
  }
};
